
import { pagination } from "@/store/modules/properties/pagination";
import { sort } from "@/store/modules/properties/sort";

export const state = {
    profile: [],
    pagination: JSON.parse(JSON.stringify(pagination)),
    sort: JSON.parse(JSON.stringify(sort)),  
};
